import React, { Component, useContext, useRef  } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';
import AppContext from '../../../AppContext';


import ClientTable from './TableComponent/client/ClientTable.js'

import {
  MDBContainer
} from 'mdb-react-ui-kit';

class ClientPage extends Component {

  constructor(props) {
  	super(props);
    this.state = {};
	}


  render(){
    return (
      <div style={{paddingLeft: "290px"}}>
        <MDBContainer className='pt-4 pt-lg-5'>
          <ClientTable />
          <div className="p-5" style={{height: "50px"}}/>
        </MDBContainer>
      </div>
    );
  }

}

export default function ClientPageFunc(props) {
    const context = useContext(AppContext);
    let [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const nodeRef = useRef(null)
    return <ClientPage context={context} searchParams={searchParams} navigate={navigate} nodeRef={nodeRef} />;
}
